import './account.css';
import { Component, h, state, css, page, signal, Fragment } from 'pylevate-runtime';
import { getMe, getWorkspace, wakeWorkspace, sleepWorkspace, setKeepAwake, getUsage } from '../api.js';
import { Nav } from '../components/nav.js';
export class Account extends Component {
  constructor(...args) {
    super(...args);
    this._email = signal('');
    this._ws = signal(null);
    this._usage = signal(null);
    this._busy = signal(false);
    this._error = signal('');
  }
  get email() { return this._email.value; }
  set email(v) { this._email.value = v; }
  get ws() { return this._ws.value; }
  set ws(v) { this._ws.value = v; }
  get usage() { return this._usage.value; }
  set usage(v) { this._usage.value = v; }
  get busy() { return this._busy.value; }
  set busy(v) { this._busy.value = v; }
  get error() { return this._error.value; }
  set error(v) { this._error.value = v; }
  async componentDidMount() {
    let me = await getMe();
    if (!__truthy(me['signed_in'])) {
      window.location.href = '/api/auth/login?next=/account';
      return;
    }
    this._email.value = me['account']['email'];
    await this.refresh();
  }
  async refresh() {
    let u;
    try {
      this._ws.value = await getWorkspace();
      u = await getUsage();
      this._usage.value = u['usage'];
    } catch (e) {
      this._error.value = String(e);
    }
  }
  async wake() {
    this._busy.value = true;
    try {
      await wakeWorkspace();
    } catch (e) {
      this._error.value = String(e);
    }
    this._busy.value = false;
    await this.refresh();
  }
  async sleep() {
    this._busy.value = true;
    try {
      await sleepWorkspace();
    } catch (e) {
      this._error.value = String(e);
    }
    this._busy.value = false;
    await this.refresh();
  }
  async toggle_keep() {
    let r;
    try {
      r = await setKeepAwake(!__truthy(this._ws.value && this._ws.value['keep_awake']));
      this._ws.value = r['workspace'];
    } catch (e) {
      this._error.value = String(e);
    }
  }
  get_context(props) {
    let w = this._ws.value || {};
    let u = this._usage.value || {};
    props['ws_label'] = (w['sleep_state'] ?? undefined) || '—';
    props['slug'] = (w['slug'] ?? undefined) || '—';
    props['url'] = (w['url'] ?? undefined) || '';
    props['keep'] = (__truthy((w['keep_awake'] ?? undefined)) ? 'on' : 'off');
    props['keep_btn'] = (__truthy((w['keep_awake'] ?? undefined)) ? 'Turn keep-awake off' : 'Keep running 24/7');
    props['storage'] = (u['storage_gb'] ?? '—');
    props['hours'] = (u['awake_hours_month'] ?? '—');
    props['credits'] = (u['credits'] ?? '—');
    props['has_ws'] = this._ws.value !== null;
    return props;
  }
  render(props, state, context) {
    const _ctx = this.get_context(props || {});
    const { ws_label, slug, url, keep, keep_btn, storage, hours, credits, has_ws } = _ctx;
    const children = props && props.children;
    return h('div', null, h(Fragment, null, h(Nav, {email: this._email.value, ws_state: (this._ws.value && this._ws.value.sleep_state) || ''}), h('div', {className: 'wrap-06d433'}, h(Fragment, null, h('div', {className: 'card-06d433'}, h(Fragment, null, h('h3', null, 'Workspace'), h('div', {className: 'kv-06d433'}, h(Fragment, null, h('span', null, 'State'), h('b', null, `${ws_label}`), h('span', null, 'Name'), h('b', null, `${slug}`), h('span', null, 'Address'), h('b', null, h('a', {href: url, target: '_blank'}, `${url}`)), h('span', null, 'Keep awake'), h('b', null, `${keep}`))), h('p', null, h(Fragment, null, h('button', {className: 'btn-06d433 primary-06d433', onClick: this.wake.bind(this), disabled: this._busy.value}, 'Wake'), h('button', {className: 'btn-06d433', onClick: this.sleep.bind(this), disabled: this._busy.value}, 'Sleep now'), h('button', {className: 'btn-06d433', onClick: this.toggle_keep.bind(this)}, `${keep_btn}`))), h('p', {className: 'muted-06d433'}, 'Asleep, a workspace costs storage only. It wakes on your next message.'))), h('div', {className: 'card-06d433'}, h(Fragment, null, h('h3', null, 'Usage this month'), h('div', {className: 'kv-06d433'}, h(Fragment, null, h('span', null, 'Storage'), h('b', null, `${storage} GB`), h('span', null, 'Awake'), h('b', null, `${hours} h`), h('span', null, 'Credits'), h('b', null, `${credits}`))))), (this._error.value ? h('p', {className: 'err-06d433'}, `${this._error.value}`) : null)))));
  }
}
Account = page({title: 'Account — Uplevate', route: '/account'})(Account);
